export default "__VITE_ASSET__COhNyQJl__"